import React from "react";

export default function Contact() {
  return (
    <section className="contact-section" id="contacto">
      <div className="contact-container">
        
        {/*1 CONTACTO */}
        <div className="contact-column">
          <h3>Contacto</h3>
          <div className="contact-info">
            <p>
              <strong>Teléfono:</strong>{" "}
              <a href="tel:+525298480796" className="contact-link">
                +52 98 48 07 96 67
              </a>
            </p>
            <p>
              <strong>WhatsApp:</strong>{" "}
              <a 
                href="https://wa.me/525298480796" 
                target="_blank" 
                rel="noopener noreferrer"
                className="contact-link"
              >
                +52 98 48 07 96 67
              </a>
            </p>
            <p>
              <strong>Email:</strong>{" "}
              <a href="mailto:contacto@dentalkaab.com" className="contact-link">
                contacto@dentalkaab.com
              </a>
            </p>
          </div>
          
          <div className="contact-buttons">
            <a 
              href="https://wa.me/529848079667" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn-contact whatsapp"
            >
              WhatsApp
            </a>
            <a 
              href="mailto:contacto@dentalkaab.com" 
              className="btn-contact email"
            >
              Enviar correo
            </a>
          </div>
        </div>

        {/* 2 QUIÉNES SOMOS */}
        <div className="contact-column">
          <h3>Quiénes Somos</h3>
          <div className="about-content">
            <p>
              Somos una Cínica de especialistas Odontológicas
              dedicada a la prevención y tratamiento de 
              enfermedades buco.dentales y maxiofaciales.
            </p>
            <p>
              En KBM siempre nos esforzaremos por brindarte la 
              mejor experiencia con la última tecnología 
              por que tu sonrisa lo vale.
            </p>
            <p>
              Vale la pena mantener una sonrisa sana, visitanos y
              nosotros hacemos el resto.
            </p>
          </div>
        </div>

        {/* 3 DIRECCIÓN */}
        <div className="contact-column">
          <h3>Dirección</h3>
          <div className="address-content">
            <p className="address-text">
              <strong>Ubicación:</strong><br />
              Plaza Coba local 223<br />
              Playa del Carmen, México<br />
              C.P. 77717
            </p>
                          <p><strong>Horarios:</strong></p>
              <p>Lunes - Viernes: 10:00 AM - 2:00 PM, 3:30pm - 07:00pm</p>
              <p>Sábados: 09:30 AM - 02:00 PM</p>
              <p>Domingos: Cerrado</p>
          </div>
        </div>

      </div>
    </section>
  );
}